import { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
} from "@mui/material";
import { UseCustomerRetention } from "./UseCustomerRetention";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { toMoney } from "../../util/Utils";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function CampaignReport(props) {
  const [campDetail, setCampDetail] = useState();
  const { getCampaignReport } = UseCustomerRetention();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (props.openReport.show) {
      setProgress(true);
      getCampaignReport(props.openReport.id, (callback) => {
        setCampDetail(callback);
      });
    }
  }, [props.openReport]);

  return (
    campDetail && (
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        maxWidth="md"
        open={props.openReport.show}
        onClose={() => {
          props.setOpenReport({ ...props.openReport, show: false });
          setCampDetail();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle color="secondary" id="alert-dialog-title">
          جزئیات گزارش کمپین
        </DialogTitle>
        <DialogContent>
          <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
            <Box gridColumn={isSmall ? "span 12" : "span 4"}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="تعداد سفارش"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={
                  campDetail.orderCount ? toMoney(campDetail.orderCount) : "0"
                }
                variant="filled"
              />
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 4"}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="تعداد کاربر"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={campDetail.userCount ? toMoney(campDetail.userCount) : 0}
                variant="filled"
              />
            </Box>

            <Box gridColumn={isSmall ? "span 12" : "span 4"}></Box>
            <Box gridColumn={isSmall ? "span 12" : "span 4"}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="اولین سفارش"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={
                  campDetail.firstOrderShamsi ? campDetail.firstOrderShamsi : ""
                }
                variant="filled"
              />
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 4"}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="آخرین سفارش"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={
                  campDetail.lastOrderShamsi ? campDetail.lastOrderShamsi : ""
                }
                variant="filled"
              />
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 4"}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="تعداد هدیه"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={campDetail.giftCount ? toMoney(campDetail.giftCount) : 0}
                variant="filled"
              />
            </Box>

            <Box gridColumn={isSmall ? "span 12" : "span 4"}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="درصد تخفیف مستقیم"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={
                  campDetail.directDiscountCostPercent
                    ? toMoney(campDetail.directDiscountCostPercent) + "%"
                    : 0
                }
                variant="filled"
              />
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 4"}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="تخفیف مستقیم"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={
                  campDetail.directDiscountCost
                    ? toMoney(campDetail.directDiscountCost)
                    : 0
                }
                variant="filled"
              />
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 4"}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="میانگین تخفیف مستقیم"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={
                  campDetail.directDiscountCostAVG
                    ? toMoney(campDetail.directDiscountCostAVG)
                    : 0
                }
                variant="filled"
              />
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 4"}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="درصد کد تخفیف"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={
                  campDetail.discountCodePercent
                    ? toMoney(campDetail.discountCodePercent) + "%"
                    : 0
                }
                variant="filled"
              />
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 4"}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="کد تخفیف"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={
                  campDetail.discountCodeCost
                    ? toMoney(campDetail.discountCodeCost)
                    : 0
                }
                variant="filled"
              />
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 4"}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="میانگین کد تخفیف"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={
                  campDetail.discountCodeCostAVG
                    ? toMoney(campDetail.discountCodeCostAVG)
                    : 0
                }
                variant="filled"
              />
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 4"}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="مجموع سفارشات"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={campDetail.orderCost ? toMoney(campDetail.orderCost) : 0}
                variant="filled"
              />
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 4"}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="میانگین مبلغ سفارش"
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  input: {
                    direction: "rtl",
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                value={
                  campDetail.orderCostAVG ? toMoney(campDetail.orderCostAVG) : 0
                }
                variant="filled"
              />
            </Box>
            <Box gridColumn={isSmall ? "span 12" : "span 4"}></Box>

            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              gridColumn="span 12"
            >
              <Button
                onClick={() => {
                  props.setOpenReport({ ...props.openReport, show: false });
                  setCampDetail();
                }}
                color="secondary"
                variant="outlined"
              >
                بستن
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    )
  );
}
